import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Cloudmigrationplatfroms() {
  return (
    <section className="cloud_migration_platfroms p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>Cloud Platforms We Leverage</h2>
            <p>
              We power your legacy applications and databases with accelerated
              migration and modernization to top-tier cloud platforms. Access
              transformational frameworks with our cloud enablement program to
              navigate right landing zones in the cloud continuum and regulate
              data authentication smarter.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="platforms_item">
                  <StaticImage
                    src="../../images/services-usa/cloud-mig/aws.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={168}
                    height={100}
                  />
                </div>
                <div className="platform_content">
                  <h5>Migrate to AWS</h5>
                  <p>
                    Optimize your cloud strategy with AWS, ensuring scalable and
                    high-performance solutions for your business units, guided
                    by our reliable cloud migration solutions.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="platforms_item">
                  <StaticImage
                    src="../../images/services-usa/cloud-mig/azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={129}
                    height={122}
                  />
                </div>
                <div className="platform_content">
                  <h5>Migrate to Azure</h5>
                  <p>
                    Access advanced cloud capabilities with Azure to boost
                    innovation and efficiency across your organization,
                    supported by our experienced cloud migration company.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="platforms_item">
                  <StaticImage
                    src="../../images/services-usa/cloud-mig/google_cloud.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={133}
                    height={107}
                  />
                </div>
                <div className="platform_content">
                  <h5>Migrate to Google Cloud</h5>
                  <p>
                    Deploy Google Cloud for agile and reliable deployments for
                    minimized downtime and maximized productivity with our
                    tailored cloud migration services.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudmigrationplatfroms;
